const displayInfo = (detail)=>{
    // console.log(detail)
    return (dispatch, getState)=>{
        dispatch({type: 'display', detail})
    }
}

export default displayInfo;